import axios from '../../utils/axios';

const getResumen = async () => {
  const response = await axios.get('/api/resume');
  return response.data;
};

const getPayments = async (clientId, startDate, endDate) => {
  const response = await axios.get(`/api/resume/payments?clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`);
  return response.data;
};

const getStoreSales = async (clientId, startDate, endDate) => {
  const response = await axios.get(`/api/resume/store-sales?clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`);
  return response.data;
};

const getTopProducts = async (clientId, startDate, endDate) => {
  const response = await axios.get(`/api/resume/top-products?clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`);
  return response.data;
};

const getMonthlyReport = async (clientId, year, month) => {
  const response = await axios.get(`/api/resume/monthly-report?clientId=${clientId}&year=${year}&month=${month}`);
  return response.data;
};

export default {
  getResumen, getPayments, getStoreSales, getTopProducts, getMonthlyReport,
};
